import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { GROCERY_LIST_QUERY_KEY } from './useGroceryList'
import { groceryListService } from './grocery-list.service'
import { showToast } from '@/shared/utils/toast'
import type { GroceryList } from './types'

export function useClearAlreadyGot() {
  const queryClient = useQueryClient()
  const { t } = useTranslation('grocery-list')

  return useMutation({
    mutationFn: () => groceryListService.clearAlreadyGot(),

    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: GROCERY_LIST_QUERY_KEY })
      const snapshot = queryClient.getQueryData<GroceryList>(GROCERY_LIST_QUERY_KEY)

      queryClient.setQueryData<GroceryList>(GROCERY_LIST_QUERY_KEY, (prev) => {
        if (!prev) return prev
        return {
          ...prev,
          alreadyGotItems: [],
        }
      })

      return { snapshot }
    },

    onError: (_err, _vars, context) => {
      if (context?.snapshot) {
        queryClient.setQueryData(GROCERY_LIST_QUERY_KEY, context.snapshot)
      }
      showToast(t('alreadyGot.clearError'))
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: GROCERY_LIST_QUERY_KEY })
    },
  })
}
